<app-notify-message></app-notify-message>
<div class="container-fluid wdth100 p-0 al-dashboard">
  <div class="row trips-page-header action-row align-items-center">
    <div class="col-md-2">
      <h5 class="mb-0">Dashboard</h5>
    </div>
    <div class="pl-4 col-md-6 my-auto p-0">
      <!-- <h6 class="text-right mr-2 mb-0">Select Vehicle</h6> -->
    </div>
    <div class="my-auto col-md-4 relative text-right">
      <div class="d-inline-block">
        <label class="d-inline">Show Previous Day Data &nbsp;</label>
        <label class="toggle-switch m-0">
          <input
            type="checkbox"
            name="enabled"
            autocomplete="off"
            [checked]="showPreviousData"
            [disabled]="isLoading"
            [(ngModel)]="showPreviousData"
            (change)="onToggle()"
          />
          <span class="toggle-switch-slider round"></span>
        </label>
      </div>
      <button
        class="btn btn-icon ml-2 refresh"
        (click)="refresh()"
        ngbTooltip="Refresh"
        placement="top"
        [disabled]="isLoading">
        <i class="fa fa-refresh" aria-hidden="true"></i>
        <span class="mob-access-text d-none">&nbsp;Refresh</span>
      </button>
    </div>
  </div>
  <!-- NRD Widget start -->
  <div class="row no-gutters mt-2 px-2">
    <div class="col-md-8 pr-2">
      <div class="widget-container" style="min-height: 375px;">
        <h5 class="headingAdd font400 widget-heading">
          Not Reporting Devices
          <i class="fa fa-cloud-download pull-right mt-1 downloadBtn"
            (click)="downloadNRDReport()" ngbTooltip="Download Report" placement="top">
          </i>
        </h5>
        <div class="widget-content mt-4">
          <!-- more than 30 days -->
          <div class="row mx-auto">
            <a class="col-3 px-0 title bold" ngbTooltip="Download CSV" (click)="downloadNRDDevices(30)">
              Not Reporting for > 30 days:
            </a>
            <span class="col-4 px-0">
              <span class="count text-blue-grey bold pr-2">
                {{(notReportingData.moreThan30Days?.ignitionOn + notReportingData.moreThan30Days?.ignitionOff) || '0'}}
              </span>
              <span class="ignition">
                <span class="ignitionOn text-blue-grey bold">
                  <i class="fa fa-circle" aria-hidden="true"></i>&nbsp;
                  {{notReportingData.moreThan30Days?.ignitionOn || '0'}}
                </span>
                <span class="ignitionOff text-blue-grey bold">
                  <i class="fa fa-circle-o" aria-hidden="true"></i>&nbsp;
                  {{notReportingData.moreThan30Days?.ignitionOff || '0'}}
                </span>
              </span>
            </span>
            <span class="col-5 text-blue-grey bold">
              <canvas id="nrd30Chart" height="50" role="img"></canvas>
            </span>
          </div>
          <!-- More than 15 days -->
          <div class="row mx-auto">
            <a class="col-3 px-0 title bold" ngbTooltip="Download CSV" (click)="downloadNRDDevices(15)">
              Not Reporting for > 15 days:
            </a>
            <span class="col-4 px-0">
              <span class="count text-blue-grey bold pr-2">
                {{(notReportingData.moreThan15Days?.ignitionOn + notReportingData.moreThan15Days?.ignitionOff) || '0'}}
              </span>
              <span class="ignition">
                <span class="ignitionOn text-blue-grey bold">
                  <i class="fa fa-circle" aria-hidden="true"></i>&nbsp;
                  {{notReportingData.moreThan15Days?.ignitionOn || '0'}}
                </span>
                <span class="ignitionOff text-blue-grey bold">
                  <i class="fa fa-circle-o" aria-hidden="true"></i>&nbsp;
                  {{notReportingData.moreThan15Days?.ignitionOff || '0'}}
                </span>
              </span>
            </span>
            <span class="col-5 text-blue-grey bold">
              <canvas id="nrd15Chart" height="50" role="img"></canvas>
            </span>
          </div>
          <!-- more than 7 days -->
          <div class="row mx-auto">
            <a class="col-3 px-0 title bold" ngbTooltip="Download CSV" (click)="downloadNRDDevices(7)">
              Not Reporting for > 7 days:
            </a>
            <span class="col-4 px-0">
              <span class="count text-blue-grey bold pr-2">
                {{(notReportingData.moreThan7Days?.ignitionOn + notReportingData.moreThan7Days?.ignitionOff) || '0'}}
              </span>
              <span class="ignition">
                <span class="ignitionOn text-blue-grey bold">
                  <i class="fa fa-circle" aria-hidden="true"></i>&nbsp;
                  {{notReportingData.moreThan7Days?.ignitionOn || '0'}}
                </span>
                <span class="ignitionOff text-blue-grey bold">
                  <i class="fa fa-circle-o" aria-hidden="true"></i>&nbsp;
                  {{notReportingData.moreThan7Days?.ignitionOff || '0'}}
                </span>
              </span>
            </span>
            <span class="col-5 text-blue-grey bold">
              <canvas id="nrd7Chart" height="50" role="img"></canvas>
            </span>
          </div>
          <!-- more than 2 days -->
          <div class="row mx-auto">
            <a class="col-3 px-0 title bold" ngbTooltip="Download CSV" (click)="downloadNRDDevices(2)">
              Not Reporting for > 2 days:
            </a>
            <span class="col-4 px-0">
              <span class="count text-blue-grey bold pr-2">
                {{(notReportingData.moreThan2Days?.ignitionOn + notReportingData.moreThan2Days?.ignitionOff) || '0'}}
              </span>
              <span class="ignition">
                <span class="ignitionOn text-blue-grey bold">
                  <i class="fa fa-circle" aria-hidden="true"></i>&nbsp;
                  {{notReportingData.moreThan2Days?.ignitionOn || '0'}}
                </span>
                <span class="ignitionOff text-blue-grey bold">
                  <i class="fa fa-circle-o" aria-hidden="true"></i>&nbsp;
                  {{notReportingData.moreThan2Days?.ignitionOff || '0'}}
                </span>
              </span>
            </span>
            <span class="col-5 text-blue-grey bold">
              <canvas id="nrd2Chart" height="50" role="img"></canvas>
            </span>
          </div>
          <!-- more than 1 day -->
          <div class="row mx-auto">
            <a class="col-3 px-0 title bold" ngbTooltip="Download CSV" (click)="downloadNRDDevices(1)">
              Not Reporting for > 1 day:
            </a>
            <span class="col-4 px-0">
              <span class="count text-blue-grey bold pr-2">
                {{(notReportingData.moreThan1Day?.ignitionOn + notReportingData.moreThan1Day?.ignitionOff) || '0'}}
              </span>
              <span class="ignition">
                <span class="ignitionOn text-blue-grey bold">
                  <i class="fa fa-circle" aria-hidden="true"></i>&nbsp;
                  {{notReportingData.moreThan1Day?.ignitionOn || '0'}}
                </span>
                <span class="ignitionOff text-blue-grey bold">
                  <i class="fa fa-circle-o" aria-hidden="true"></i>&nbsp;
                  {{notReportingData.moreThan1Day?.ignitionOff || '0'}}
                </span>
              </span>
            </span>
            <span class="col-5 text-blue-grey bold">
              <canvas id="nrd1Chart" height="50" role="img"></canvas>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- NRD Widget end -->
    <!-- Main battery widget start -->
    <div class="col-md-4">
      <div class="widget-container" style="min-height: 375px;">
        <h5 class="headingAdd font400 widget-heading">Main Battery Events</h5>
        <div class="widget-content mt-4">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Time Range</th>
                <th scope="col">Connected</th>
                <th scope="col">Disconnected</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span class="text-dark-grey bold">Last 24 Hours</span></td>
                <td><span class="text-blue-grey bold">{{batteryStatus.oneDay?.connected || 0}}</span></td>
                <td><span class="text-blue-grey bold">{{batteryStatus.oneDay?.disConnected || 0}}</span></td>
              </tr>
              <tr>
                <td><span class="text-dark-grey bold">1 - 7 days</span></td>
                <td><span class="text-blue-grey bold">{{batteryStatus.oneToSevenDays?.connected || 0}}</span></td>
                <td><span class="text-blue-grey bold">{{batteryStatus.oneToSevenDays?.disConnected || 0}}</span></td>
              </tr>
              <tr>
                <td><span class="text-dark-grey bold">7 - 15 days</span></td>
                <td><span class="text-blue-grey bold">{{batteryStatus.sevenToFifteenDays?.connected || 0}}</span></td>
                <td><span class="text-blue-grey bold">{{batteryStatus.sevenToFifteenDays?.disConnected || 0}}</span></td>
              </tr>
              <tr>
                <td><span class="text-dark-grey bold">15 - 30 days</span></td>
                <td><span class="text-blue-grey bold">{{batteryStatus.fifteenToThirtyDays?.connected || 0}}</span></td>
                <td><span class="text-blue-grey bold">{{batteryStatus.fifteenToThirtyDays?.disConnected || 0}}</span></td>
              </tr>
              <tr>
                <td><span class="text-dark-grey bold">> 30 days</span></td>
                <td><span class="text-blue-grey bold">{{batteryStatus.moreThanThirtyDays?.connected || 0}}</span></td>
                <td><span class="text-blue-grey bold">{{batteryStatus.moreThanThirtyDays?.disConnected || 0}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- Main battery widget end -->
  <!-- Vpacket widget start -->
  <div class="row no-gutters mt-2 px-2">
    <div class="col-md-6 pr-2">
      <div class="widget-container">
        <h5 class="headingAdd font400 widget-heading">
          V Packet
          <i class="fa fa-cloud-download pull-right mt-1 downloadBtn"
            (click)="downloadVPacketReport()" ngbTooltip="Download Report" placement="top">
          </i>
        </h5>
        <div class="widget-content mt-4">
          <div class="row mx-auto">
            <span class="col-7 title text-dark-grey bold">Continious 100 V Packets while moving:</span>
            <span class="col-5 text-blue-grey bold">{{vPacketData.continueInvalid || 0}}</span>
            <span class="col-7 title text-dark-grey bold">< 30%:</span>
            <span class="col-5 text-blue-grey bold">{{vPacketData.invalidFixLessThanThirty || 0}}</span>
            <span class="col-7 title text-dark-grey bold">30 - 50%:</span>
            <span class="col-5 text-blue-grey bold">{{vPacketData.invalidFixThirtyToFifty || 0}}</span>
            <span class="col-7 title text-dark-grey bold">50 - 80%:</span>
            <span class="col-5 text-blue-grey bold">{{vPacketData.invalidFixFiftyToEighty || 0}}</span>
            <span class="col-7 title text-dark-grey bold">80 - 100%:</span>
            <span class="col-5 text-blue-grey bold">{{vPacketData.invalidFixEightyToHundred || 0}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- V packet widget end -->
    <!-- Network latency widget start -->
    <div class="col-md-6">
      <div class="widget-container">
        <h5 class="headingAdd font400 widget-heading">Network Latency for {{date}}</h5>
        <div class="widget-content mt-4">
          <div class="row mx-auto">
            <div class="col-6">
              <div class="row">
                <span class="col-7 title text-dark-grey bold">0 - 5 minutes:</span>
                <span class="col-5 text-blue-grey bold">{{networkLatencyData.zeroToFive || 0}}</span>
                <span class="col-7 title text-dark-grey bold">5 - 15 minutes:</span>
                <span class="col-5 text-blue-grey bold">{{networkLatencyData.fiveToFifteen || 0}}</span>
                <span class="col-7 title text-dark-grey bold">15 - 30 minutes:</span>
                <span class="col-5 text-blue-grey bold">{{networkLatencyData.fifteenToThirty || 0}}</span>
                <span class="col-7 title text-dark-grey bold">30 - 1 hour:</span>
                <span class="col-5 text-blue-grey bold">{{networkLatencyData.thirtyToOneHr || 0}}</span>
                <span class="col-7 title text-dark-grey bold">1 - 3 hours:</span>
                <span class="col-5 text-blue-grey bold">{{networkLatencyData.oneHrToThreeHr || 0}}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <span class="col-7 title text-dark-grey bold">3 - 6 hours:</span>
                <span class="col-5 text-blue-grey bold">{{networkLatencyData.threeHrToSixHr || 0}}</span>
                <span class="col-7 title text-dark-grey bold">6 - 9 hours:</span>
                <span class="col-5 text-blue-grey bold">{{networkLatencyData.sixHrToNineHr || 0}}</span>
                <span class="col-7 title text-dark-grey bold">9 - 12 hours:</span>
                <span class="col-5 text-blue-grey bold">{{networkLatencyData.nineHrToTwelveHr || 0}}</span>
                <span class="col-7 title text-dark-grey bold">12 - 24 hours:</span>
                <span class="col-5 text-blue-grey bold">{{networkLatencyData.twelveHrToTwentyFourHr || 0}}</span>
                <span class="col-7 title text-dark-grey bold">> 24 hours:</span>
                <span class="col-5 text-blue-grey bold">{{networkLatencyData.greaterTwentyFourHr || 0}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Network latency widget end -->
  <!-- Bootstrap status widget start -->
  <div class="row no-gutters my-2 px-2">
    <div class="col-md-6 pr-2">
      <div class="widget-container">
        <h5 class="headingAdd font400 widget-heading">Bootstrap Status</h5>
        <div class="widget-content mt-4">
          <div class="row mx-auto">
            <span class="col-5 title text-dark-grey bold">Expiring in < 30 days:</span>
            <span class="col-7 text-blue-grey bold">{{deviceExpiryData.bootstrap.lessThanThirty || 0}}</span>
            <span class="col-5 title text-dark-grey bold">Expiring in 45 days:</span>
            <span class="col-7 text-blue-grey bold">{{deviceExpiryData.bootstrap.thirtyToFortyFive || 0}}</span>
            <span class="col-5 title text-dark-grey bold">Expiring in 60 days:</span>
            <span class="col-7 text-blue-grey bold">{{deviceExpiryData.bootstrap.fortyFiveToSixty || 0}}</span>
            <span class="col-5 title text-dark-grey bold">Expiring in 90 days:</span>
            <span class="col-7 text-blue-grey bold">{{deviceExpiryData.bootstrap.sixtyToNinety || 0}}</span>
            <span class="col-5 title text-dark-grey bold">Total Expired:</span>
            <span class="col-7 text-blue-grey bold">{{deviceExpiryData.bootstrap.expired || 0}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Bootstrap status widget end -->
    <!-- Commercial status widget start -->
    <div class="col-md-6">
      <div class="widget-container">
        <h5 class="headingAdd font400 widget-heading">Commercial Status</h5>
        <div class="widget-content mt-4">
          <div class="row mx-auto">
            <span class="col-5 title text-dark-grey bold">Expiring in < 30 days:</span>
            <span class="col-7 text-blue-grey bold">{{deviceExpiryData.commercial.lessThanThirty || 0}}</span>
            <span class="col-5 title text-dark-grey bold">Expiring in 45 days:</span>
            <span class="col-7 text-blue-grey bold">{{deviceExpiryData.commercial.thirtyToFortyFive || 0}}</span>
            <span class="col-5 title text-dark-grey bold">Expiring in 60 days:</span>
            <span class="col-7 text-blue-grey bold">{{deviceExpiryData.commercial.fortyFiveToSixty || 0}}</span>
            <span class="col-5 title text-dark-grey bold">Expiring in 90 days:</span>
            <span class="col-7 text-blue-grey bold">{{deviceExpiryData.commercial.sixtyToNinety || 0}}</span>
            <span class="col-5 title text-dark-grey bold">Total Expired:</span>
            <span class="col-7 text-blue-grey bold">{{deviceExpiryData.commercial.expired || 0}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- Commercial status widget end -->
  </div>
</div>
